import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import { ClipLoader } from "react-spinners";

import { useStore } from "../store";
import Notification, { Types } from "../base-components/Notification";
import StepIndicator from "../components/StepIndicator";

const SecondaryLayout = () => {
  const loading = useStore.useLoading();

  const notification = useStore.useNotification();
  const setNotification = useStore.useSetNotification();

  useEffect(() => {
    const handleOffline = () =>
      setNotification({
        message: "Интернэт холболтоо шалгаад дахин оролдоно уу.",
        type: Types.warning,
      });

    window.addEventListener("offline", handleOffline);
    if (!navigator.onLine) handleOffline();
    return () => window.removeEventListener("offline", handleOffline);
  }, [setNotification]);

  return (
    <div className="h-full flex justify-center">
      <div className="relative bg-primary-disabled h-max min-h-full w-full sm:w-[420px] md:w-[420px] lg:w-[420px] xl:w-[420px] p-4">
        <div
          className={twMerge([
            "flex justify-center items-center z-50 absolute top-0 bottom-0 right-0 left-0 bg-primary opacity-30",
            !loading && "hidden",
          ])}
        >
          <ClipLoader color="#fff" size={40} />
        </div>
        <Notification notification={notification} />
        <StepIndicator />
        <Outlet />
      </div>
    </div>
  );
};

export default SecondaryLayout;
